import React from "react";
import { hasProperty } from "../../../../utils/validate";

const OldButtons = ({ banner, setOpenBATD }) => {
	return (
		<>
			{hasProperty(banner, "link") && banner.link != null && banner.link.type === "Entry" && (
				<a
					title={banner.link.text}
					href={banner.link.url}
					className="waves-effect waves-light btn-large bbred"
				>
					{banner.link.text}
				</a>
			)}

			{hasProperty(banner, "link") && banner.link != null && banner.link.type === "Url" && (
				<a
					title={banner.link.text}
					href={banner.link.url}
					className="waves-effect waves-light btn-large bbred"
					onClick={(e) => {
						setOpenBATD(e, banner.link);
					}}
				>
					{banner.link.text}
				</a>
			)}

			{hasProperty(banner, "secondary") && banner.secondary != null && banner.secondary.url != null && (
				<a
					title={banner.secondary.text}
					href={banner.secondary.url}
					className="waves-effect waves-light btn-large bbwhite"
					download={banner.secondary.url ? banner.secondary.url : false}
					target={banner.secondary.url ? "_blank" : "_self"}
				>
					{banner.secondary.text
						? banner.secondary.text
						: "Download brochure"}
				</a>
			)}
		</>
	);
};

export default OldButtons;